export default {
    deletedBehavior_deletedMetric: 'Deleted Metric',
    deletedBehavior_deletedMetric_success: 'Metric Deleted Successfully',
    deletedBehavior_metricMessage: 'Are you sure you want to delete this metric?',
    deletedBehavior_metricsMessage: 'Are you sure you want to clear the selected metrics?',
    deletedBehavior_allMetricsMessage: 'Are you sure you want to delete all selected metrics?',
}
